export default {
  en: {
    id: 'exercise2',
    blocks: [
      {
        task: `Current Risk Management benchmarks/processes misstate actual risk positions, unreliable for developing card-marketing strategies.`,
        title: "S = ",
        prop: 's',
        answer: ' ',
        note: 'DE, Sit',
        disableEdit: true
      },
      {
        task: `Have developed new benchmarks/processes that will correct the problems, need you to participate in pilot trial.`,
        title: "C = ",
        prop: 'c',
        answer: ' ',
        note: 'R1, R2, Sol',
        disableEdit: true
      },
      {
        task: 'Should we?',
        title: "Q = ",
        prop: 'q',
        answer: ' ',
        disableEdit: true
      }
    ],
    subtitle: 'SUGGESTED STRUCTURE RISK MANAGEMENT STUDY BENCHMARK ADVANTAGE',
    image: '5d4-2.png',
    withoutAnswers: true,
    hideTaskTitle: true,
    submitButton: 'switch'
  },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise2.js